import React from "react";
import {
	View, Text, StyleSheet, TouchableOpacity, AsyncStorage,
	Platform, Dimensions, Image, I18nManager, SectionList
} from "react-native";

import * as firebase from "firebase";
import * as Font from 'expo-font';
import { color } from "../config/color"
import store from "../config/config.json"

import { Ionicons } from "@expo/vector-icons";
import { SearchBar } from 'react-native-elements';
import PlaceholderComp from "../utilities/PlaceholderComp";
import Main from "../widgets/Main";
import i18n from 'i18n-js';
import MainComponent from "../utilities/MainComponent";
import AppContext from "../utilities/AppContext"

const om = require('../assets/flag_om.png');
const kw = require('../assets/flag_kw.png');
const bh = require('../assets/flag_bh.png');
const ae = require('../assets/flag_ae.png');
const qa = require('../assets/flag_qa.png');
const sa = require('../assets/flag_sa.png');

export default class AreaScreen extends MainComponent {

	static path = "area";

	state = {
		deliveryData: { area: "", timings: "" },
		isLoading: true,
		showFullMode: true,
		search: "",
		item: {},
		data: [],
		expandLocations: false,
		fakeData: new Array(10).fill({})
	};

	static navigationOptions = {
		headerShown: false
	};

	constructor(props) {
		super(props);

		this.state.flags = {
			'om' : om,
			'kw' : kw,
			'bh' : bh,
			'ae' : ae,
			'qa' : qa,
			'sa' : sa
		};

		let screenWidth = window.innerWidth;
		let screenHeight = window.innerHeight;

		this.state.height = screenHeight
		this.state.width = screenWidth

		if (screenWidth < color.screenLimit) {
			this.state.showFullMode = false;
		} else {
			this.state.showFullMode = true;
		}
	}

	componentDidMount() {

		Dimensions.addEventListener('change', (e) => {
			const { width, height } = e.window;
			this.setState({ height: height, width: width })
			if (width < color.screenLimit) {
				this.setState({ showFullMode: false });
			} else {
				this.setState({ showFullMode: true });
			}
		})

		this.updateSearch = this.updateSearch.bind(this)
		this.setState({ item: this.context.deliveryData })
		this.getDetails()
	}

	getDetails = async () => {
		const that = this

		try {

			var value = await AsyncStorage.getItem(store.storeData)
			if (value == undefined)
				value = {}
			else {
				value = JSON.parse(value)
				this.setState({ store: value })
			}

		} catch (error) {
			console.log(error)
		}

		if (!this.state.store.enableDelivery && !this.state.store.soonAvailability && !this.state.store.enableCustomDelivery) {
			this.props.navigation.navigate('menu');
			return
		}

		var locations = [];
	 	this.state.store.locations?.forEach(element => {
			if(element.status)
				locations.push(element);	 
		});

		that.setState({ locations: locations, selectedLocation: locations.length > 0 ? locations[0] : undefined });
		if (locations.length > 0)
			that.setupLocations(locations[0]);

		/*
		var locations = [];
		firebase.database().ref("locations").once("value", function (snapshot) {
			if (snapshot.exists()) {

				snapshot.forEach(function (childSnapshot) {
					const country = childSnapshot.val();
					if (country.status) {
						locations.push(country);
					}
				});
			}

			if (locations.length > 0) {
				that.setState({ locations: locations, selectedLocation: locations[0] });
				that.setupLocations(locations[0]);
			}
		});
		*/
		this.setState({ isLoading: false })
		await Font.loadAsync(color.appFonts);
	}

	setupLocations(location) {
		let deliveryData = this.context.deliveryData
		var area = deliveryData.area
		if (area == undefined) {
			area = { name: "" }
		}

		var mMainList = []
		var index = 0
		location.cities.map(obj => {
			if (obj.status) {
				var items = []
				var areas = obj.areasList

				areas.map(mObj => {
					if (mObj.status) {
						if (area.name == mObj.name) {
							items.push({ isSelected: true, name: mObj.name, nameArabic: mObj.nameArabic, area: mObj })
						} else {
							items.push({ isSelected: false, name: mObj.name, nameArabic: mObj.nameArabic, area: mObj })
						}
					}
				})

				let item = { isExpanded: true, name: obj.name, nameArabic: obj.nameArabic, data: items, origData: items, index: index }
				mMainList.push(item)
				index += 1
			}
		});

		this.setState({ data: mMainList, deliveryData: deliveryData });
	}

	backBtnPressed() {
		this.props.navigation.goBack(null)
	}

	listRowPressed = async (item) => {

		if (this.state.deliveryData == undefined || this.state.deliveryData.timings == undefined
			|| this.state.deliveryData.timings == {} || this.state.deliveryData.timings == '') {
			this.state.deliveryData = { area: item.area, timings: "" }
			await AsyncStorage.setItem(store.delivery, JSON.stringify(this.state.deliveryData))

			this.setState({ deliveryData: this.state.deliveryData }, () => {
				if (this.state.deliveryData.timings == undefined || this.state.deliveryData.timings.length == 0) {
					if (this.state.store.soonAvailability) {
						this.state.deliveryData = { area: item.area, timings: { date: "Order Now" } }
					} else if (this.state.store.enableCustomDelivery) {
						this.state.deliveryData = { area: item.area, timings: { date: this.state.store.customDeliveryText } }
					} else {
						this.state.deliveryData = { area: item.area, timings: { date: "Order Now" } }
					}

					var updateFunc = this.context.onUpdate
					this.context.deliveryData = this.state.deliveryData
					this.props.navigation.navigate('menu');
					updateFunc(this.state.deliveryData)
					return
				}

				this.state.onUpdate = this.context.onUpdate
				this.state.deliveryData = { area: item.area, timings: "" }
				this.context.deliveryData = this.state.deliveryData
				this.context.onUpdate = this.onSelectTimings.bind(this)
				this.props.navigation.navigate('scheduled');
			})
			return
		}

		this.state.deliveryData = { area: item.area, timings: this.state.deliveryData.timings }
		await AsyncStorage.setItem(store.delivery, JSON.stringify(this.state.deliveryData))

		var updateFunc = this.context.onUpdate
		this.context.deliveryData = this.state.deliveryData
		this.props.navigation.navigate('menu');
		updateFunc(this.state.deliveryData)
	}

	onSelectTimings = async data => {
		var updateFunc = this.state.onUpdate
		this.context.deliveryData = data
		this.props.navigation.navigate('menu');
		updateFunc(data)
	};

	updateSearch(name) {

		const location = this.state.selectedLocation;
		if (!location) {
			return;
		}

		if (name == "" || name == undefined) {
			this.setupLocations(location);
			this.setState({ search: name });
		}
		else {

			let deliveryData = this.context.deliveryData
			var area = deliveryData.area
			if (area == undefined) {
				area = { name: "" }
			}

			var mMainList = []
			var index = 0

			location.cities.map(obj => {

				if (obj.status) {
					var items = []
					var areas = obj.areasList
					areas.map(mObj => {
						if (mObj.status) {
							if (mObj.name.toLowerCase().includes(name.toLowerCase()) || mObj.nameArabic.toLowerCase().includes(name.toLowerCase())) {
								if (area.name == mObj.name) {
									items.push({ isSelected: true, name: mObj.name, nameArabic: mObj.nameArabic, area: mObj })
								} else {
									items.push({ isSelected: false, name: mObj.name, nameArabic: mObj.nameArabic, area: mObj })
								}
							}
						}
					})

					let item = { isExpanded: true, name: obj.name, nameArabic: obj.nameArabic, data: items, origData: items, index: index }
					mMainList.push(item)
					index += 1
				}
			});

			this.setState({ search: name, data: mMainList })
		}
	}

	setArea(mCat) {

		let index = mCat.index
		let isExpanded = !mCat.isExpanded

		let mCategory = this.state.data[index];
		mCategory.isExpanded = isExpanded
		this.state.data.splice(mCategory.index, 1, mCategory);
		var categories = []
		this.state.data.map(category => {
			if (category.isExpanded) {
				category.data = category.origData
				categories.push(category)
			}
			else {
				let mCategory = { isExpanded: false, name: category.name, nameArabic: category.nameArabic, data: [], origData: category.origData, index: category.index }
				categories.push(mCategory)
			}
		})

		this.setState({ data: categories })
	}

	/****
	 * 
	 * 
	 * 
	 * 
	 * 
	 */

	renderSearchHeader(that) {
		//var that = this

		const location = that.state.selectedLocation;
		const flags = that.state.flags;

		var name = location?.name || "";

		if (i18n.locale == "ar") {
			name = location?.nameArabic || "";
		}

		if (name == undefined || name == "")
			name = location?.name || "";

		var locations = [... that.state.locations || []];
		if (location) {
			let index = locations.findIndex(loc => loc.code === location.code);
			if (index > -1)
				locations.splice(index, 1);
		}

		var height = 130;
		if (that.state.expandLocations && that.state.locations?.length > 0) {
			height += (that.state.locations.length - 1) * 60;
		}

		return (
			<View style={{ height: height }}>

				<TouchableOpacity style={{ marginTop: 20, flexDirection: "row", justifyContent: "center", marginRight: 15 }}
					onPress={() => {
						that.setState({expandLocations: !that.state.expandLocations});
					}}
				>

					<Image source={location ? flags[location.code] : ''} style={{ marginTop: 5, width: 24, height: 16, overflow:"hidden", marginLeft: 15, }}/>
					<Text style={{ marginLeft: 10, height: 50, fontFamily: 'main-bold', fontWeight: "normal", color: "black", fontSize: 18 }}>{name}</Text>
					{that.state.expandLocations && locations.length > 0 && (<Ionicons style={{ marginLeft: "auto" }} name="ios-arrow-down" size={24} color="black" />)}
					{!that.state.expandLocations && locations.length > 0 && (<Ionicons style={{ marginLeft: "auto" }} name="ios-arrow-up" size={24} color="black" />)}

				</TouchableOpacity>

				<View style={{ height: 1, backgroundColor: color.bigSeparator, justifyContent: "center" }} />

				{that.state.expandLocations && (
					<View 
					>
						{locations.map(currLocation => (
							<TouchableOpacity onPress={() => {
									that.setState({selectedLocation: currLocation, expandLocations: false});
									that.setupLocations(currLocation);
								}}
								style={{ height: 60}}
							>
								<View style={{ marginLeft: 20, height: 59, flexDirection: "row", alignItems: 'center' }}>
										<Image source={flags[currLocation.code]} style={{ width: 24, height: 16, overflow:"hidden", marginLeft: 15, }}/>
										<Text style={{ marginLeft: 10, fontFamily: 'main-regular', fontWeight: "normal", color: "black", fontSize: 16 }}>{currLocation.name}</Text>
								</View>
								<View style={{ height: 1, backgroundColor: color.bigSeparator, justifyContent: "center" }} />
							</TouchableOpacity>
						))}

					</View>
				)}
				
				<SearchBar
					inputStyle={{ outline: "none", textAlign: "left", fontSize: 14, fontFamily: "main-regular" }}
					inputContainerStyle={{ backgroundColor: '#F5F5F5', borderRadius: 10 }}
					containerStyle={{
						backgroundColor: 'rgba(0,0,0,0)', borderBottomColor: color.bigSeparator,
						borderTopColor: 'transparent', marginLeft: 10, marginRight: 10,
					}}
					lightTheme={true}
					placeholder={i18n.t("searchCities")}
					onChangeText={that.updateSearch}
					value={that.state.search}
				/>

				<View style={{ height: 1, backgroundColor: color.bigSeparator, justifyContent: "center" }} />

			</View>

		)
	}

	renderListItem = ({ item, index }) => {
		var name = item.name

		if (i18n.locale == "ar") {
			name = item.nameArabic
		}

		if (name == undefined || name == "")
			name = item.name

		return (
			<TouchableOpacity
				onPress={() => this.listRowPressed(item)}
			>
				<View style={{ height: 50 }}>
					<View style={{ flexDirection: "row", height: 49, alignContent: "center", alignItems: "center" }}>
						{item.isSelected && (<View style={{ width: 3, height: 50, backgroundColor: this.state.store.primaryColor, justifyContent: "center" }} />)}
						{!item.isSelected && (<View style={{ width: 3, height: 50, backgroundColor: 'white', justifyContent: "center" }} />)}
						<View style={{ marginLeft: 12 }}>
							<Text style={{ fontFamily: 'main-regular', fontWeight: "normal", color: "black", fontSize: 14 }}>{name} </Text>
						</View>
					</View>
					<View style={{ marginLeft: 15, height: 1, backgroundColor: color.bigSeparator, justifyContent: "center" }} />
				</View>
			</TouchableOpacity>
		);
	}

	renderHeader = ({ section }) => {
		var height = 50
		if (section.index >= 0)
			height += 8

		var name = section.name
		if (i18n.locale == "ar") {
			name = section.nameArabic
		}

		if (name == undefined || name == "")
			name = section.name

		return (
			<View style={{ height: height, backgroundColor: "white" }}>
				{section.index >= 0 && (<View style={{ height: 8, backgroundColor: "white", justifyContent: "center" }} />)}
				<TouchableOpacity style={{ marginLeft: 15, marginRight: 15, height: 49, justifyContent: "center" }}
					onPress={() => { this.setArea(section) }}
				>
					<View style={{ flexDirection: "row", justifyContent: "center" }}>
						<Text style={{ fontFamily: 'main-bold', color: "black", fontSize: 16 }}>{name} </Text>
						{section.isExpanded && (<Ionicons style={{ marginLeft: "auto" }} name="ios-arrow-down" size={24} color="black" />)}
						{!section.isExpanded && (<Ionicons style={{ marginLeft: "auto" }} name="ios-arrow-up" size={24} color="black" />)}
					</View>

				</TouchableOpacity>
				<View style={{ height: 1, backgroundColor: color.bigSeparator, justifyContent: "center" }} />
			</View>
		);
	}

	// List View 
	renderDetails() {

		return (
			<View style={{ flex: 1 }}>

				<TouchableOpacity style={{ height: 50, marginTop: 50, justifyContent: "center", alignContent: "center", alignItems: "center", borderBottomWidth: 1, borderBottomColor: 'black' }}
					onPress={() => { }}
				>
					<Text style={{ fontFamily: 'main-regular', color: 'black', fontSize: 15 }}>{i18n.t("delivery")}</Text>
				</TouchableOpacity>

				{this.state.data.length > 0 && (

					<SectionList
						ListHeaderComponent={this.renderSearchHeader(this)}
						stickySectionHeadersEnabled
						sections={this.state.data}
						renderItem={this.renderListItem}
						renderSectionHeader={this.renderHeader}
					/>

				)}

				{this.state.data.length == 0 && (
					this.renderSearchHeader(this)
				)}

				{this.isLoading && (
					this.state.fakeData.map((e, i) => <PlaceholderComp key={i} />)
				)}
			</View>
		)
	}

	render() {

		//this.setupLocations()
		var icoName = "ios-arrow-back"
		if (I18nManager.isRTL)
			icoName = "ios-arrow-forward"

		var that = this
		return (

			<AppContext.Consumer>
				{ (context) => (
					<View style={styles.container} ref={(ref) => {
						this.context = context;
					}}>

						{this.state.showFullMode && (

							<View style={styles.webContainer}>

								<View style={{ backgroundColor: color.backgroundColor, height: this.state.height, width: this.state.width * .33 }}>

									{that.renderDetails()}

									<View style={styles.topBar}>
										<View style={{ width: '100%', position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center" }}>
											<Text style={{ color: 'black', fontFamily: "main-bold", textAlign: "center", fontSize: 16 }}>{i18n.t('orderMode')}</Text>
										</View>
										<TouchableOpacity style={{ height: 40, width: 40, justifyContent: "center", alignContent: "center", alignItems: "center" }}
											onPress={() => { this.props.navigation.goBack(null) }} >
											<Ionicons name={icoName} size={24} color={'black'} />
										</TouchableOpacity>
									</View>

								</View>

								<Main {...this.state} changeMenu={this.changeMenu} />

							</View>
						)}

						{!this.state.showFullMode && !this.state.showMenu && (
							<View style={styles.container}>

								<View style={{ backgroundColor: color.backgroundColor, height: this.state.height }}>
									{that.renderDetails()}
								</View>

								<View style={styles.topBar}>
									<View style={{ flex: 1, width: "100%", position: "absolute", justifyContent: "center", alignContent: "center", alignItems: "center" }}>
										<Text style={{ color: 'black', fontFamily: "main-bold", textAlign: "center", fontSize: 16 }}>{i18n.t('orderMode')}</Text>
									</View>
									<TouchableOpacity style={{ height: 40, width: 40, justifyContent: "center", alignContent: "center", alignItems: "center" }}
										onPress={() => { this.props.navigation.goBack(null) }} >
										<Ionicons name={icoName} size={24} color={'black'} />
									</TouchableOpacity>
								</View>

							</View>
						)}

					</View>

				)}
			</AppContext.Consumer>

		);
	}
}

const styles = StyleSheet.create({
	container: {
		flex: 1,
		backgroundColor: color.bigSeparator
	},
	webContainer: {
		flex: 1,
		flexDirection: "row",
	},
	topBar: {
		backgroundColor: "white",
		position: "absolute",
		width: "100%",
		height: 50,
		flexDirection: "row",
		alignContent: "center",
		alignItems: "center"
	}
});